// src/components/ProtectedRoute.js
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, token, loading } = useAuth();

  // ⏳ Mientras verifica token (refreshToken) mostramos un estado de carga
  if (loading) {
    return <div className="p-4">Verificando sesión...</div>;
  }

  // ❌ Si no hay token ni usuario, redirige al login
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
